import Box from "@mui/material/Box"

export const MainContainer = ({ children }) => {
    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                minWidth: 0,
                height: '100vh',
                bgcolor: 'background.default'
            }}
        >
            {children}
        </Box>
    );
}